(function(){
  "use strict";
  angular.module('eclipseApp.checkout').controller('existingJanrainUserModalCtrl', ['$scope', '$modalInstance', 'data', '$window', 'janrainService',function ($scope, $modalInstance, data, $window, janrainService) {

    $scope.ok = function () {
      $modalInstance.close();
    };

    $scope.cancel = function () {
      if (data && data.focusEmail) {
        data.focusEmail();
      }
      $modalInstance.close();
    };

    $scope.enter = $scope.cancel;

    $scope.login = function(){
      $modalInstance.close();
      // $window.janrain.capture.ui.renderScreen('signIn');
      janrainService.renderLogin(); // Added for sign in issue for the existing user
    };

  }]);

})();
